import { createFileRoute } from '@tanstack/react-router';
import { SegmentOutRouteView } from '@/pages/workspaces/journeys/integrations/segment-out/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware branch of the resolver
 * rebuilds the target from the bundle prefix — which would find no `/journeys/` here, drop the
 * sub-path, and land on the Journeys home instead of this connector.
 */
function SegmentOutRoute() {
  return (
    <LastWorkspaceResolver>
      <SegmentOutRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/segment_out')({
  component: SegmentOutRoute,
});
